module.exports = __webpack_public_path__ + "images/bg-login-4117df9a.png";